import { Page } from '../pages/policy/dmca';

export default function () {
  return (
    <Page />
  );
};
